import React, {useEffect, useState} from 'react';
import {INITIAL_MUSIC_VOLUME, LOCAL_STORAGE_KEY_MUSIC_VOLUME} from "../../constants/sound";
import '../VolumeSlider/VolumeSlider.css';
import {usePrev} from "../../hooks/react/usePrev";

const MusicVolumeSlider = () => {
  const [volume, setVolume] = useState(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY_MUSIC_VOLUME);
    if (stored === null) {
      localStorage.setItem(LOCAL_STORAGE_KEY_MUSIC_VOLUME, INITIAL_MUSIC_VOLUME.toString());
      return INITIAL_MUSIC_VOLUME;
    }
    const parsed = parseFloat(stored);
    return isNaN(parsed) ? INITIAL_MUSIC_VOLUME : Math.max(0, Math.min(1, parsed));
  });

  const prevVolume = usePrev(volume);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY_MUSIC_VOLUME, volume.toString());

    if (prevVolume !== undefined) {
      window.dispatchEvent(new CustomEvent('musicvolumechange', {detail: {volume}}));
    }
  }, [volume, prevVolume]);

  return (
    <div className="volume-slider-container">
      <img
        className="volume-slider-icon"
        src={'/img/icons/music.png'}
        alt={'Громкость музыки'}
      />
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={(e) => setVolume(parseFloat(e.target.value))}
        className="volume-slider"
      />
      <span className="volume-slider-value">{Math.round(volume * 100)}%</span>
    </div>
  );
};

export default MusicVolumeSlider;
